var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import getBreakpointsFromValues from '@jetshop/core/helpers/getBreakpointsFromValues';
import { Above } from '@jetshop/ui/Breakpoints';
import { cx } from 'linaria';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SnappyReactGrid } from 'snappy-react-grid';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
const SnappyReactGridWithId = SnappyReactGrid;
function WindowGridInner({ id, items, className = '', prevOffset, itemsPerRow = 0, component }) {
    // Keep pagination in URL in sync with scrolling
    const { perPage, goToPage, currentPage } = useContext(PaginationContext);
    const [scrollOffsetPage, setScrollOffsetPage] = useState(null);
    // Updates the url query, the history and triggers a refetch for products
    const updateHistory = useCallback(({ firstVisibleIndex }) => {
        const pageForIndex = Math.floor((firstVisibleIndex + (prevOffset + perPage)) / perPage + 1);
        setScrollOffsetPage(pageForIndex);
    }, [perPage, prevOffset]);
    useEffect(() => {
        if (scrollOffsetPage && scrollOffsetPage !== currentPage) {
            goToPage(scrollOffsetPage, { replace: true });
        }
    }, [scrollOffsetPage, currentPage, goToPage]);
    return (React.createElement("div", { "data-testid": "product-grid" },
        React.createElement(SnappyReactGridWithId, { id: id, className: cx('product-grid', className), columns: itemsPerRow, items: items, component: component, onScroll: updateHistory, defaultVisible: perPage || 16 })));
}
const WindowGridWrapper = (_a) => {
    var { itemsPerRow = [2, null, 3, 4] } = _a, props = __rest(_a, ["itemsPerRow"]);
    const { theme: { breakpoints: themeBreakpoints } } = useShopConfig();
    if (Array.isArray(itemsPerRow)) {
        const breakpoints = getBreakpointsFromValues(itemsPerRow, Object.keys(themeBreakpoints));
        // Walk down each breakpoint until we find a match, starting at the biggest.
        // This should be rewritten whenever we have support for media queries in hooks.
        return breakpoints.reduce((acc, cur) => (React.createElement(Above, { breakpoint: cur.breakpoint }, (match) => {
            if (match) {
                return React.createElement(WindowGridInner, Object.assign({ itemsPerRow: cur.value }, props));
            }
            else {
                return acc;
            }
        })), 
        // Fallback to the smallest breakpoint
        React.createElement(WindowGridInner, Object.assign({ itemsPerRow: breakpoints[0].value }, props)));
    }
    return null;
};
export const WindowGrid = WindowGridWrapper;
//# sourceMappingURL=WindowGrid.js.map